<template>
    <div class="learn-rank">
        <div class="header">
            <div class="back" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </div>
            <div class="title">List of the {{caregry==='year'?$t('business_school.year'):$t('business_school.month')}}</div>
            <div class="sub">{{$t('business_school.period_of_statistics')}}: {{dataObj.startDate.replace("-", ".")}}-{{dataObj.endDate.replace("-", ".")}}</div>
            <div class="btnGroup">
                <div @click="changeBtn('year')" :class="['btn',caregry==='year'?'activeBtn':'']">{{$t('business_school.annual')}}</div>
                <div @click="changeBtn('month')" :class="['btn',caregry==='month'?'activeBtn':'']">{{$t('business_school.monthly')}}</div>
            </div>
        </div>
        <div class="main" :class="[{'allShow':tabValue!==1&&tabValue!==0}]">
            <van-tabs class="tab" line-width="25%" :ellipsis="false" animated v-model:active="tabValue"  @change="onClickTab">
                <van-tab v-for="item in tabs" :title="item.title" :name="item.value" :key="item.value">
                    <van-list v-model:loading="loading" :finished="finished" :finished-text="$t('business_school.no_more')" @load="onLoad" >
                        <van-cell v-for="item in list" :key="item.rank">
                            <div class="lisRank">
                                <div class="rank">{{item.ranks}}</div>
                                <div class="userinfo">
                                    <div class="image">
                                        <van-image :round="tabValue!==3"
                                        fit="cover" :src="$utils.setSourcePath(tabValue===3?item.preview:tabValue===0?item.avatar:item.headimg)"/>
                                    </div>
                                    <div class="info" v-if="tabValue===3">
                                        <strong class="name ellipsis2">{{item.title}}</strong>
                                    </div>
                                    <div class="info" v-else>
                                        <strong class="name ellipsis">{{item.firstName}} {{item.lastName}}</strong>
                                        <span class="dec ellipsis">{{item.levelName}}</span>
                                    </div>
                                </div>
                                <div class="number" v-if="tabValue!==3">
                                    {{ item.point }}{{item.countStar}}
                                </div>
                                <div class="number" v-else>
                                    {{item.star}}
                                </div>
                            </div>
                        </van-cell>
                    </van-list>
                </van-tab>
            </van-tabs>
        </div>
        <div class="foot" v-show="tabValue<=1">
            <div class="lisRank">
                <div class="rank">{{userInfo.ranks}}</div>
                <div class="userinfo">
                    <div class="image">
                        <van-image round
                        fit="cover" :src="$utils.setSourcePath(userInfo.headimg||userInfo.avatar)"/>
                    </div>
                    <div class="info">
                        <strong class="name ellipsis">{{userInfo.firstName}} {{userInfo.lastName}}</strong>
                        <span class="dec ellipsis">{{userInfo.levelName}}</span>
                    </div>
                </div>
                <div class="number">
                    {{userInfo.point}}
                </div>
            </div>
        </div>
        <van-popup v-model:show="showPicker" class="selectDate" :style="{ width: '70%'}" round closeable>
            <h3 class="title">{{$t('text.select')}} {{ caregry==='year'?$t('business_school.by_date'):$t('business_school.budget') }}</h3>
            <van-picker :default-index="4-(new Date().getFullYear()-pickerYear)" v-if="caregry==='year'" :columns="columns" @change="onChange" />
            <van-picker :default-index="pickerMonth" v-if="caregry==='month'" :columns="columns" @change="onChange" />
            <sd-button class="confirm" @click.native="confirm">{{$t('text.confirm')}}</sd-button>
        </van-popup>
    </div>
</template>

<script>
import { uniqBy } from 'lodash';

export default {
    name: "cases",
    components: {  },
    data() {
        return {
            lang: 'en',
            list: [],
            userInfo: {},
            page: {
                current: 0,
                size: 10,
                total: 0
            },
            loading: false,
            finished: false,
            tabs: [
                {
                    title:this.$t('business_school.overall_points_ranking'),
                    value:0
                },{
                    title:this.$t('business_school.learning_points_ranking'),
                    value:1
                },{
                    title:this.$t('text.lecturers_points_ranking'),
                    value:2
                },{
                    title:this.$t('business_school.course_scoring_ranking'),
                    value:3
                },
            ],
            tabValue: 0,
            columns: [ ],
            pickerYear: null,
            pickerMonth: null,
            showPicker: false,
            caregry: 'year',
            dataObj: {
                startDate: '',
                endDate: ''
            }
        }
    },

    computed: {
        
    },

    watch: {
        caregry:{
            handler(val,oldVal){
                if (val==='year') {
                    const currentYear = new Date().getFullYear();
                    for (let index = 0; index < 5; index++) {
                        this.columns[index] = { text: (currentYear - 4 + index) + '年', value: currentYear - 4 + index };
                    }
                    // this.columns = [
                    // { text: '2021年', value: 2021 },
                    // { text: '2022年', value: 2022 },
                    // { text: '2023年', value: 2023 },
                    // { text: '2024年', value: 2024 },
                    // { text: '2025年', value: 2025 },
                    // ]
                } else { 
                    
                    this.columns = [
                    { text: this.$t('text.january'), value: 1 },
                    { text: this.$t('text.february'), value: 2 },
                    { text: this.$t('text.march'), value: 3 },
                    { text: this.$t('text.april'), value: 4 },
                    { text: this.$t('text.may'), value: 5 },
                    { text: this.$t('text.june'), value: 6 },
                    { text: this.$t('text.july'), value: 7 },
                    { text: this.$t('text.august'), value: 8 },
                    { text: this.$t('text.september'), value: 9 },
                    { text: this.$t('text.october'), value: 10 },
                    { text: this.$t('text.november'), value: 11 },
                    { text: this.$t('text.december'), value: 12 },
                    ]
                }
            },
            immediate:true
        }
    },

    mounted() {
        const header = JSON.parse(localStorage.getItem('header'))
        this.lang = header['Blade-Lang']
        
        this.pickerYear = new Date().getFullYear();
        this.handlerDate(new Date().getFullYear())
    },

    methods: {
        handlerDate(year, month = null){
            let startDate, endDate;
            if (month === null) {
                // 获取全年范围
                startDate = new Date(year, 0, 1); // 1月1日
                endDate = new Date(year, 11, 31); // 12月31日
            } else {
                
                // 获取当月范围
                startDate = new Date(year, month, 1); // 当月第一天
                
                // 下个月的第0天 = 当月的最后一天
                endDate = new Date(year, month + 1, 0);
            }
            // 返回ISO格式的日期字符串（去掉时间部分）
            this.dataObj.startDate = this.formatDate(startDate);
            this.dataObj.endDate = this.formatDate(endDate);
            
        },
        formatDate (date) {
            console.log(date);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要加1
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        getCourseData(){
            let params = {
                lang: this.lang,
                startDate: this.dataObj.startDate,
                endDate: this.dataObj.endDate,
                current: this.page.current+1
            }
            let fn;
            if (this.tabValue===0) {
                fn = this.$apis.school.getPointRanking
            }else if (this.tabValue===1) {
                fn = this.$apis.school.getCoursePointRanking
            }
            fn(params).then(res=>{
                this.userInfo = res.data
                this.page = this.tabValue===0 ? res.data.rankPageList : res.data.list
                // this.page = this.userInfo.list
                // if (this.page.current===2||this.list.length===20) {
                //     this.loading = false
                //     return
                // }
                let resList = [...this.list,...this.page.records]
                this.list = uniqBy(resList,'ranks')
                this.loading = false
                if (this.page.total<=this.list.length) {
                    this.finished = true
                }
                console.log(this.list);
                
            })
        },
        getCourseTeacherData(){
            let params = {
                lang: this.lang,
                startDate: this.dataObj.startDate,
                endDate: this.dataObj.endDate,
                current: this.page.current+1
            }
            let fn;
            if (this.tabValue===2) {
                fn = this.$apis.school.getTeacherRanking
            }else if (this.tabValue===3) {
                fn = this.$apis.school.getCourseRanking
            }
            fn(params).then(res=>{
                this.userInfo = {}
                this.page = res.data
                // const records = res.data.records.map(item=>({}))
                let resList = [...this.list,...res.data.records]
                this.list = uniqBy(resList,'ranks')
                this.loading = false
                if (this.page.total===this.list.length) {
                    this.finished = true
                }
            })
        },
        onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        // setTimeout(() => {
        //     for (let i = 0; i < 10; i++) {
        //         this.list.push({
        //             rank: this.list.length+1,
        //             name: 'demo'+(this.list.length+1),
        //             dec: 'demo'+(this.list.length+1),
        //             number: Math.floor(Math.random() * 100) + 1
        //         });
        //     }
        //     // 加载状态结束
        //     this.loading = false;
        //     // 数据全部加载完成
        //     if (this.list.length >= 40) {
        //         this.finished = true;
        //     }
        // }, 1000);
        if (this.tabValue===1||this.tabValue===0) {
            this.getCourseData()
        }else {
            this.getCourseTeacherData()
        }
        },
        onClickTab(){
            this.list = []
            this.page = {
                current: 0,
                size: 10,
                total: 0
            }
            this.finished = false
            this.loading = true
            this.onLoad()
        },
        confirm(type){
            this.page.current = 0;
            this.list = [];
            if ((type?type:this.caregry)==='year') {
                this.handlerDate(this.pickerYear);
                // this.dataObj.startDate = `${this.pickerYear}-01-01`;
                // this.dataObj.endDate = `${this.pickerYear}-12-31`;
            } else {
                this.handlerDate(this.pickerYear, this.pickerMonth);
            //     this.dataObj.startDate = `${this.pickerYear}-${this.pickerMonth}-01`;
            //     this.dataObj.endDate = `${this.pickerYear}-${this.pickerMonth}-${new Date(this.pickerYear, this.pickerMonth, 0).getDate()}`;
            }
            if (this.tabValue===1||this.tabValue===0) {
                this.getCourseData()
            }else {
                this.getCourseTeacherData()
            }
            this.showPicker = false;
        },
        onChange (selectedValues,selectedOptions) {
            if (this.caregry === 'year') {
                this.pickerYear = selectedOptions.value;
            } else {
                this.pickerMonth = selectedOptions.value;
                
            }
        },
        changeBtn(val){
            console.log("val:"+val+' '+' caregry:'+this.caregry);
            
            if (val===this.caregry) {
                this.showPicker = true
            }else {
                console.log(val==='month');
                if (val==='month') {
                    this.pickerMonth = new Date().getMonth(); // 获取当前月份
                } else {
                    this.pickerYear = new Date().getFullYear(); // 获取当前年份
                }
                this.confirm(val)
            }
            this.caregry = val
            console.log(this.pickerMonth);
            
        },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
    },

    beforeDestroy() {
    }
}
</script>

<style lang="scss">
.learn-rank {
    background: #F4F5F8;
    height: 100%;
    overflow: auto;
    font-size: 14px;
    // display: flex;
    // flex-direction: column;
    .header{
        display: flex;
        box-sizing: border-box;
        padding: 20px;
        flex-direction: column;
        text-align: left;
        height: 150px;
        justify-content: space-between;
        .back{
            width: 20px;
            height: 20px;
            border-radius: 50%;
            // background: rgba(0,0,0,0.3);
            left: 0;
            top: 20px;
            line-height: 20px;
            position: absolute;
            i{
                font-size: 18px;
            }
        }
        .title{
            font-size: 20px;
            font-weight: 600;
        }
        .sub{
            color: #7b828f;
        }
        .btnGroup{
            display: flex;
            justify-content: center;
            width: 200px;
            height: 30px;
            font-size: 16px;
            font-weight: bold;
            color: #7b828f;
            .btn{
                text-align: center;
                line-height: 30px;
                width: 50%;
                padding-left: 10px;
                background-color: #fff;
            }
            .btn:first-child{
                border-radius: 15px 0 0 15px;
            }
            .btn:last-child{
                border-radius: 0 15px 15px 0;
            }
        }
        .activeBtn{
            background-color: #E22F25 !important;
            color: #fff;
        }
    }
    .main{
        height: calc(100% - 200px);
        // overflow: auto;
        // flex: 1;
        .tab {
            height: 100%;
          .van-tab__text{
                font-size: 14px;
            }  
            .van-tabs__wrap{
                height: 44px;
            }
            .van-tabs__content{
                height: calc(100% - 44px);
                overflow: auto;
                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }
        .lisRank{
            display: flex;
            width: 100%;
            align-items: center;
            text-align: center;
            font-size: 14px;
            .rank{
                width: 10%;
            }
            .userinfo{
                width: 80%;
                display: flex;
                align-items: center;
                text-align: left;
                padding-left: 10px;
                .image{
                    .van-image{
                        width: 40px;
                        height: 40px;
                    }
                }
                .info{
                    height: 40px;
                    margin-left: 10px;
                    .ellipsis{
                        vertical-align: middle;
                        height: 50%;
                        line-height: 20px
                    }
                }
            }
            .number{
                width: 10%;
                color: red;
                font-weight: bold;
            }
        }
    }
    .allShow{
        height: calc(100% - 150px);
    }
    .foot{
        height: 50px;
        width: calc(100% - 32px);
        background-color: #fff;
        padding: 0 16px;
        .lisRank{
            border-radius: 10px;
            background-color: rgba(0, 0, 0, 0.5);
            color: #fff;
            height: 100%;
            display: flex;
            align-items: center;
            .rank{
                width: 10%;
            }
            .userinfo{
                width: 80%;
                display: flex;
                align-items: center;
                text-align: left;
                padding-left: 10px;
                .image{
                    .van-image{
                        width: 40px;
                        height: 40px;
                    }
                }
                .info{
                    margin-left: 10px;
                }
            }
            .number{
                width: 10%;
                font-weight: bold;
            }
        }
    }
}
.selectDate{
    .confirm{
        width: 80% !important;
        margin: 10%;
    }
    .van-picker-column__item--selected{
        color: #E22F25;
    }
}
.van-list__error-text, .van-list__finished-text, .van-list__loading {
    font-size: 14px;
    line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/pages/school/rank.vue